import { render, staticRenderFns } from "./UpdateServicePopUp.vue?vue&type=template&id=0d44e8ee&"
import script from "./UpdateServicePopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateServicePopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports